import { render, staticRenderFns } from "./Cart3.vue?vue&type=template&id=b09a1978"
import script from "./Cart3.vue?vue&type=script&lang=js"
export * from "./Cart3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports